var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeBannerFromRightBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6626 19.2353C22.8544 19.1498 23.0592 19.1489 23.2375 19.2174C23.4157 19.2858 23.5674 19.4235 23.6528 19.6154L25.7881 24.4115L12.085 30.5125L9.94958 25.7164C9.86417 25.5246 9.86327 25.3197 9.93169 25.1415C10.0001 24.9632 10.1378 24.8116 10.3297 24.7262L22.6626 19.2353Z",
    stroke: "#00805B",
    strokeWidth: 1.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1031 24.4524C22.6707 24.1997 22.9259 23.5347 22.6732 22.9671C22.4205 22.3995 21.7555 22.1442 21.1879 22.3969C20.6203 22.6496 20.365 23.3146 20.6177 23.8822C20.8704 24.4498 21.5354 24.7051 22.1031 24.4524Z",
    fill: "#00805B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42317 15.2061L6.15062 14.8961C5.42636 14.7999 4.73215 15.2321 4.49958 15.9267C4.25866 16.6579 4.45719 17.4726 5.0142 18.0046L11.373 24.1549L21.945 19.448C21.7766 16.8384 21.1459 14.2786 20.0812 11.8874L19.5901 10.7843",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4746 15.3225L4.81397 7.10063C4.49367 6.38121 4.81676 5.53953 5.53618 5.21923C5.55673 5.21008 5.58414 5.19787 5.60469 5.18872C6.39037 4.88817 7.27701 5.25693 7.61867 6.0243L10.3641 12.1907",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2443 14.1711L9.68849 10.6767C9.37429 9.97103 9.68978 9.14915 10.3955 8.83495C10.4297 8.81969 10.4572 8.80749 10.4914 8.79224C11.29 8.50234 12.1729 8.881 12.5176 9.65523L13.9849 12.9508",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.035 13.0608L13.0405 10.8272C12.7202 10.1078 13.0433 9.2661 13.7627 8.94579C13.7833 8.93664 13.8107 8.92444 13.8313 8.91529C14.6169 8.61474 15.5036 8.98349 15.8452 9.75087L16.7726 11.8337",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6681 11.5998L16.4699 11.1544C16.1404 10.4144 16.4711 9.55296 17.2111 9.22351C17.2248 9.21741 17.2385 9.2113 17.2453 9.20825C18.015 8.8902 18.9024 9.2422 19.244 10.0096L19.5155 10.6194",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6953 31.1309L16.1766 28.6904",
    stroke: "#00805B",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBannerFromRightBtn);
export default __webpack_public_path__ + "static/media/home-banner-from-right-btn.ce6f9148df6a25a55b8794399be961f7.svg";
export { ForwardRef as ReactComponent };